import { render, staticRenderFns } from "./website-zdjs.vue?vue&type=template&id=0a5a4fa2&scoped=true"
import script from "./website-zdjs.vue?vue&type=script&lang=js"
export * from "./website-zdjs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a4fa2",
  null
  
)

export default component.exports